import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateGroupTypeDto {
  @ApiProperty({ type: 'string', description: 'Code du type de groupe', example: 'CLUB' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: 'Nom du type de groupe', example: 'Club' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
